<ng-select 
    name="beneficiaria" 
    [items]="beneficiarias" 
    bindValue="id" 
    [placeholder]="placeholder" 
    [required]="required"
    [disabled]="disabled"
    [loading]="loading"
    [searchFn]="searchFn" 
    [(ngModel)]="selectedBeneficiaria" 
    [compareWith]="compareWith"
    (change)="onBeneficiariaChange($event)">
    <ng-template ng-label-tmp ng-option-tmp let-item="item" let-search="searchTerm">
        {{ item.nome }}
    </ng-template>
</ng-select>